export default "https://cdn-static.gokick.com/assets/c0e4f86ff5da21e4b09546702d214e718bb56dad/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";